var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-right"},[_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":_vm.onPull}},[_vm._v("同步")])],1),_c('app-table',{ref:"app-table",staticClass:"mt-20",attrs:{"table-key":_vm.table_key,"tablep":_vm.table_params,"table-props":{'max-height': '450px'},"get-data":_vm.getAssetsList()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }